module.exports = __webpack_public_path__ + "static/Carly_Daniel3-f3526472a63b7783ef1b804f6dc84e49.jpg";